import * as entityActions from '../actions/entityActions';

export default function entityReducer(state = {}, action) {
  switch (action.type) {
    case entityActions.ENTITIES_ADDED:
      return { ...state, ...action.entities };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/entityReducer.js